import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class OciWebShop<T extends EMode = EMode.entity> {
  /** Alias: id */
  id?: string;
  /** Alias: name */
  name?: string;
  /** Alias: url */
  url?: string;
  /** Alias: userName */
  userName?: string;
  /** Alias: customerNumber */
  customerNumber?: string;
  /** Alias: password */
  password?: string;
  /** Alias: sDObjMembercode */
  sDObjMembercode?: number;

  __typename?: string;
}

const fields: FieldDefinitions<OciWebShop> = {
  id: {
    alias: 'id',
  },
  name: {
    alias: 'name',
  },
  url: {
    alias: 'url',
  },
  userName: {
    alias: 'userName',
  },
  customerNumber: {
    alias: 'customerNumber',
  },
  password: {
    alias: 'password',
  },
  sDObjMembercode: {
    alias: 'sDObjMembercode',
  },
  __typename: {
    alias: '__typename',
  },
};

export const ociWebShopEntityDefinition: EntitiyDefinition<OciWebShop> = {
  local: {},
  remote: {
    queryName: 'getOciWebShopDefinitions',
    fragmentName: 'OciWebShop',
    withPaginationWrapper: false,
    mutations: {
      upsert: {
        mutationName: 'upsertOciWebShop',
        args: [
          { name: 'input', type: 'InputOciWebShop!' },
          { name: 'drySave', type: 'Boolean' },
        ],
      },
    },
  },
  fieldDefinitions: fields,
};
